import OptionValue from '../inputs/OptionValue';
import { axiosInstance } from './ApiConfig';
import { countConnections } from '../function/HandleMLChange';
import handleInputChange from '../function/HandleInputsChange';
import resultToInputs from '../function/resultToInputs';

async function FetchOptionsMain(
  inputs,
  setInputs,
  setOptions,
  focusedInput,
  result,
  initNbrWindings,
  amtIndex,
  setAmtIndex
) {
  try {
    const normalizedInputs = Object.fromEntries(
      Object.entries(inputs).map(([key, value]) =>
        value === ''
          ? [key, null]
          : key === 'nbr_windings' && initNbrWindings !== null
            ? [key, initNbrWindings]
            : [key, value]
      )
    );

    const resultOverrides = {};
    if (result && typeof result === 'object') {
      for (const key of resultToInputs) {
        if (!normalizedInputs[key] && result[key] !== undefined) {
          resultOverrides[key] = result[key];
        }
      }
    }

    const processedInputs = {
      ...normalizedInputs,
      ...resultOverrides,
    };

    const request = JSON.stringify({
      input: processedInputs,
      amt: !amtIndex,
    });

    const response = await axiosInstance({
      method: 'POST',
      url: '/options',
      data: request,
    });

    const optionsPayload = response.data?.value || {};
    const options = optionsPayload.res || [];

    if (!amtIndex && optionsPayload.amt) {
      setAmtIndex(optionsPayload.amt);
    }

    try {
      if (inputs.connection_conveyor !== null && options.length > 0) {
        const counts = countConnections(
          options,
          inputs.connection_conveyor,
          inputs.ml_connection
        );
        Object.keys(counts).forEach((key) => {
          if (options.some((option) => option.field === key))
            handleInputChange(key, counts[key], inputs, setInputs, setOptions);
        });
      }

      const resultWithValue = OptionValue(
        inputs,
        setInputs,
        options,
        setOptions,
        focusedInput,
        result
      );
      setOptions(resultWithValue);
    } catch (error) {
      console.error('Error in OptionValue:', error);
      console.log('Result:', options);
    }
  } catch (error) {
    console.log(
      JSON.stringify({
        input: inputs,
      })
    );
    console.error('Error fetching options:', error);
  }
}

export default FetchOptionsMain;
